// (function($) {
//     $(".js-open-popup").click(function(){
//         $(".popup").addClass("visible");
//     });
    
//     $(".js-close-popup").click(function(){
//         $(".popup").removeClass("visible");
//     });
    
// })(jQuery);

import owd from 'owd/owd';

export default class Popup extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('click', this.dom.$body, '.js-open-popup',(e) => {
           this.$element.addClass("visible");
           $(window).scrollTop(window);
           if($(e.currentTarget).hasClass('js-open-popup-findmore')) { //Find out more contact form
                this.$element.find('.popup-heading').text("Find out more");
                this.$element.find('.popup-txt').text("We will get back to you once you leave us a note how to reach you.");

                this.$element.find('.js-label-toggle').text("Perhaps you have a question?");

                let star = $("<span class='star js-span-toggle'> *</span>");
                star.insertAfter(this.$element.find('.company_name-label'));
                $('.js-required-toggle').attr('required', '');
                $('.js-placeholder-toggle').attr('placeholder', 'If so, we will be glad to answer...');

            } else { //Contact us contact form
                this.$element.find('.popup-heading').text("Contact us");
                this.$element.find('.popup-txt').text("Would you like to embrace some exceptional challenges with us?");

                this.$element.find('.js-label-toggle').text("What is your expertise area?");
                $('.js-placeholder-toggle').attr('placeholder', 'Let us see if there is a fit...');
            }
        });
        this.on('click', '.js-close-popup',(e) => {
            this.$element.removeClass("visible");
            this.$element.find('.ajax-message').hide();
            $('.js-span-toggle').remove();
            $('.js-required-toggle').removeAttr('required');
         });
         this.on('click',(e) => {
            if(this.$element.hasClass('visible') && !$(e.target).is('.popup-container') && !$(e.target).parents('.popup-container').length) {
                this.$element.removeClass("visible");
                this.$element.find('.ajax-message').hide();
                $('.js-span-toggle').remove();
                $('.js-required-toggle').removeAttr('required');
            }
            
         });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('popup', {
	component: Popup
});
